import { Col, Form, InputNumber, Modal, Row } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { MOMENT_CANTIDAD_UNIDAD_MEDIDA } from '../constants';
import { useSolicitudContext } from '../context/solicitud-context';
import { formatoMonedaGenerico } from '../utils/converters';
import TextWithEditButton from './TextWithEditButton';

/*
  Formulario y tabla del Calendario de Pagos
*/

const dateFormat = 'DD/MM/YYYY';

const backgroundColor = '#fafafa';
const border = '#f0f0f0';
const borderSolid = '#f0f0f0';

const style = {
  padding: 5,
  width: '100%',
  maxWidth: 150,
  // minWidth: 150,
  backgroundColor,
  borderBottom: `1px solid ${border}`,
  borderRight: `1px solid ${border}`
};

const CalendarioPagosForm = ({ plan, moneda }) => {
  const [form] = Form.useForm();
  const [calendarioPagosList, setCalendarioPagosList] = useState([]);
  const [vigenciaPagosForm, setVigenciaPagosForm] = useState();
  const [validateFields, setValidateFields] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [vigenciaPagos, setVigenciaPagos] = useState();
  const [mostrarEdit, setMostrarEdit] = useState(false);

  const {
    vigenciaPagosContext,
    setCalendarioPagosContext,
    calendarioForm,
    setCalendarioForm
  } = useSolicitudContext();

  const onBlurDiaPago = (e) => {
    const { value } = e.target;
    const validarDiaPago = true;
    getCalendarioPagosList(Number(value), validarDiaPago);
  };

  const getCalendarioPagosList = (diaMes, validarDiaPago) => {
    setValidateFields(false);
    const fechaPagoInicio = vigenciaPagosForm?.desde
      ? moment(vigenciaPagosForm.desde).clone()
      : moment();

    if (
      vigenciaPagosForm &&
      vigenciaPagosForm.pagos &&
      vigenciaPagosForm.pagos.frecuencia
    ) {
      const frecuenciaUnidadMedida = MOMENT_CANTIDAD_UNIDAD_MEDIDA.find(
        (item) => item.codigo === vigenciaPagosForm.pagos.frecuencia.codigo
      );
      const newCalendarioList = [];
      let superaFechaMax = false;
      for (let i = 0; i < vigenciaPagosForm.pagos.cantidad_pagos; i += 1) {
        const fechaPago = fechaPagoInicio.clone().set('date', diaMes);
        const pago = { numero: null, fecha: null };
        const numero = i + 1;
        pago.fecha = moment(fechaPagoInicio).format(dateFormat);
        pago.numero = numero;
        pago.fechaVencimiento = fechaPagoInicio;
        pago.monto = plan.inicial;
        if (i !== 0) {
          const fechaPagoCalculado = fechaPago.add(
            Number(Number(frecuenciaUnidadMedida.cantidad) * i),
            frecuenciaUnidadMedida.codigo_moment
          );
          pago.fecha = moment(fechaPagoCalculado).format(dateFormat);
          pago.fechaVencimiento = fechaPagoCalculado;
          if (i === 1) {
            const fechaPagoMaxSiguiente = fechaPagoInicio
              .clone()
              .add(
                Number(frecuenciaUnidadMedida.cantidad),
                frecuenciaUnidadMedida.codigo_moment
              );

            if (fechaPagoCalculado.isAfter(fechaPagoMaxSiguiente, 'day')) {
              superaFechaMax = true;
              break;
            }
          }
        }
        newCalendarioList.push(pago);
      }
      if (!validarDiaPago) {
        if (!superaFechaMax) {
          setCalendarioPagosList(newCalendarioList);
          setCalendarioPagosContext(newCalendarioList);
          setValidateFields(false);
        } else {
          setValidateFields(true);
        }
      } else if (superaFechaMax) {
        setValidateFields(true);
      }
    }
  };

  const showModal = () => {
    form.setFieldsValue(calendarioForm);
    setValidateFields(false);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    if (!validateFields) {
      setIsModalOpen(false);

      const value = form.getFieldValue('dia_mes');
      calendarioForm.dia_mes = value;

      const validarDiaPago = false;
      getCalendarioPagosList(Number(value), validarDiaPago);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (calendarioForm) {
      form.setFieldsValue(calendarioForm);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, calendarioForm]);

  useEffect(() => {
    if (vigenciaPagosForm) {
      getCalendarioPagosList(Number(calendarioForm.dia_mes));
      const desdeFormMoment = moment(vigenciaPagosForm?.desde);
      const desdeValidateMoment = moment(vigenciaPagos?.desde);
      if (desdeFormMoment.isSame(desdeValidateMoment, 'day')) {
        getCalendarioPagosList(Number(calendarioForm.dia_mes));
      } else {
        const newCalendarioForm = {
          ...calendarioForm,
          dia_mes: vigenciaPagos?.desde
            ? vigenciaPagos.desde.get('date')
            : moment().get('date')
        };
        setCalendarioForm(newCalendarioForm);

        getCalendarioPagosList(
          vigenciaPagos?.desde ? vigenciaPagos.desde.get('date') : moment()
        );
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vigenciaPagosForm, plan]);

  useEffect(() => {
    if (vigenciaPagos) {
      const fechaMoment = moment(vigenciaPagos?.desde);
      if (fechaMoment.isValid()) {
        const newCalendarioForm = {
          ...calendarioForm,
          fecha: fechaMoment.format(dateFormat),
          dia_mes: calendarioForm.dia_mes
            ? calendarioForm.dia_mes
            : fechaMoment.get('date')
        };
        setCalendarioForm(newCalendarioForm);
      }
    }

    setVigenciaPagosForm(vigenciaPagos);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vigenciaPagos]);

  useEffect(() => {
    if (vigenciaPagosContext) {
      setVigenciaPagos(vigenciaPagosContext);
      if (
        vigenciaPagosContext &&
        vigenciaPagosContext.pagos &&
        vigenciaPagosContext.pagos.cantidad_pagos > 1 &&
        vigenciaPagosContext.pagos.frecuencia.codigo !== 'semanal'
      ) {
        setMostrarEdit(true);
      } else {
        setMostrarEdit(false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vigenciaPagosContext]);

  return (
    <div>
      <Row gutter={[16, 16]} justify="center">
        {mostrarEdit && (
          <Col xs={24}>
            <div style={{ display: 'inline-block' }}>
              <TextWithEditButton
                type="secondary"
                descripcion={`Día de Pago, cada ${calendarioForm.dia_mes} del mes correspondiente`}
                tituloEditTooltip="Editar Día de Pago"
                onClick={showModal}
                hidden={!mostrarEdit}
                hoverable={false}
              />
            </div>
          </Col>
        )}

        <Col xs={24}>
          <div style={{ display: 'inline-block' }}>
            <table
              style={{
                textAlign: 'center',
                width: '100%',
                borderRadius: 6,
                border: `1px solid ${borderSolid}`
              }}
              className="table"
            >
              <tbody>
                <tr>
                  <td
                    style={{ ...style, maxWidth: '80px' }}
                    className="sticky-header"
                  >
                    Cuota
                  </td>
                  <td style={style} className="sticky-header">
                    Fecha Vencimiento
                  </td>
                  <td
                    style={{ ...style, textAlign: 'right' }}
                    className="sticky-header"
                  >
                    Monto
                  </td>
                </tr>

                {calendarioPagosList.length > 0 &&
                  calendarioPagosList.map((calendarioPago, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          textAlign: 'center',
                          padding: '5px'
                        }}
                      >
                        {calendarioPago.numero}
                      </td>
                      <td
                        style={{
                          textAlign: 'center',
                          padding: '5px'
                        }}
                      >
                        {calendarioPago.fecha}
                      </td>
                      <td
                        style={{
                          textAlign: 'end',
                          padding: '5px',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {formatoMonedaGenerico(moneda, calendarioPago.monto)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
      <Modal
        title="Editar Día de Pago"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        bodyStyle={{ textAlign: 'center', width: '400px' }}
      >
        <Form
          id="myForm"
          name="calendario"
          layout="horizontal"
          initialValues={calendarioForm}
          form={form}
          autoComplete="off"
          labelCol={{ span: 12 }}
          wrapperCol={{ span: 12 }}
          style={{ width: '250px' }}
          // forceRender
        >
          <>
            <Form.Item
              label="Día de Pago"
              name="dia_mes"
              rules={[
                { required: true, message: 'Requerido' },
                {
                  validator: (_, value) => {
                    if (value && validateFields) {
                      // eslint-disable-next-line prefer-promise-reject-errors
                      return Promise.reject(
                        `La fecha de pago de la última cuota, no puede ser posterior a la fecha de finalización de la vigencia`
                      );
                    }

                    return Promise.resolve();
                  }
                }
              ]}
              validateTrigger="onBlur"
            >
              <InputNumber
                onBlur={onBlurDiaPago}
                style={{ width: '100px' }}
                min={0}
                max={31}
              />
            </Form.Item>
          </>
        </Form>
      </Modal>
    </div>
  );
};

export default CalendarioPagosForm;
